<template>
  <div class="developer">
    <TopNav :curTabProps="'3'" />
    <el-row type="flex" justify="start" class="choose-date">
      <!-- <ChooseDate :dateValue.sync="dateValue"/> -->
      <ChooseDateAndCustomer :showCustomer="false" @paramsInfo="receiveParamsInfo" />
    </el-row>
    <el-row class="title-block" type="flex" justify="start">
      <div style="background:#A89700!important;">功能组件服务分析</div>
    </el-row>
    <el-row class="summary-row">
      <el-col :span="12">
        <div class="chart-summary">
          <!-- <el-row type="flex" justify="start">
      <div style="background:#A89700!important;">功能组件服务分析</div>
    </el-row> -->
          <!-- 柱状图 -->
          <div>
            <div style="width: 100%;height:300px;">
              <BarChart :barDataProps="clientBarDataProps" />
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="12">
          <!-- 下载图表 -->
          <div>
            <TableForDownload 
              :tableColumnsProps="clientTabColumns"
              :tableDataProps="clientTableData"
              :themeColor="{color:'#A89700',colorOpa: 'rgba(168, 151, 0, 0.05)'}"/>
          </div>
      </el-col>
      <!-- <el-col :span="12">
        <div class="chart-summary">
          <el-row type="flex" justify="start">
            <div>客户端服务分析</div>
          </el-row>
          <div>
            <div style="width: 100%;height:300px;">
              <div v-if="JSON.stringify(sdkTypeBarDataProps[0])==='[]'&&JSON.stringify(sdkTypeBarDataProps[1])==='[]'">
                <el-empty style="width: 100%; height: 300px;" description="暂无数据"></el-empty>
              </div>
              <BarChart v-else :barDataProps="sdkTypeBarDataProps" />
            </div>
          </div>
          <div>
            <TableForDownload style="margin-top: 30px"
              :tableColumnsProps="sdkTypeTabColumns"
              :tableDataProps="sdkTypeTableData"
              :themeColor="{color:'#33CDCD',colorOpa: 'rgba(51, 205, 205, 0.05)'}"/>
          </div>
        </div>
      </el-col> -->
      <!-- <el-col :span="12">
        <div class="chart-summary">
          <el-row type="flex" justify="start">
            <div style="background:#A89700!important;">功能组件服务分析</div>
          </el-row>
          <div>
            <div style="width: 100%;height:300px;">
              <BarChart :barDataProps="clientBarDataProps" />
            </div>
          </div>
          <div>
            <TableForDownload style="margin-top: 30px"
              :tableColumnsProps="clientTabColumns"
              :tableDataProps="clientTableData"
              :themeColor="{color:'#A89700',colorOpa: 'rgba(168, 151, 0, 0.05)'}"/>
          </div>
        </div>
      </el-col> -->
    </el-row>
  </div>
</template>
<script>
import TopNav from '../Components/topNav.vue'
// import ChooseDate from '../Components/chooseData.vue'
import TableForDownload from '../Components/tabeleFordownload.vue'
import BarChart from '@/components/chartComponents/bar.vue'
import ChooseDateAndCustomer from '../Components/chooseDataAndCustomer.vue'

export default {
  components: {
    TopNav,
    // ChooseDate,
    TableForDownload,
    BarChart,
    ChooseDateAndCustomer
  },
  data() {
    return {
      dateValue: '',
      clientTabColumns: [
        {key: '',label: '序号'},
        {key: 'type',label: '功能组件'},
        {key: 'duration',label: '服务时长（分钟）'},
        {key: 'cnt',label: '服务次数'},
      ],
      sdkTypeTabColumns: [
        {key: '',label: '序号'},
        {key: 'type',label: '客户端程序'},
        {key: 'duration',label: '服务时长（分钟）'},
        {key: 'cnt',label: '服务次数'},
      ],
      // 客户端服务分析
      clientTableData: [],
      sdkTypeBarDataProps: [[],[]],
      // 功能服务组件
      sdkTypeTableData: [],
      clientBarDataProps: [[],[]],
      // *****************************************产品分析-new
      summaryParmasInfo: {// 查询产品分析需要的查询参数
        statUnit: 'currentDay',
      },
    }
  },
  watch: {
    'summaryParmasInfo': {
      handler(val) {
        this.getAnalysis();
        // if(val==='today') {
        //   this.getTodayAnalysis();
        // }else if(val==='week'||val==='month'||val==='year') {
        //   this.getHistoryAnalysis();
        // }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    // this.getTodayAnalysis();
  },
  methods: {
    receiveParamsInfo(val) {
      console.log(val)
      this.summaryParmasInfo = val;
    },
    getAnalysis() {
      this.resetData();
      let params = {
        ...this.summaryParmasInfo
      }
      this.getRequest('/dev/system/dvw/prod/analysis', params).then(res => {
        if(res.status===200 && res.data.code ===1000) {
          let data = res.data.result;
          this.clientTableData = data.funcComponentCntAndDuration;
          data.funcComponentCntAndDuration.map(item => {
            this.clientBarDataProps[0].push(item.type);
            this.clientBarDataProps[1].push(item.duration);
          });
        }
      })
    },
    // getTodayAnalysis() {
    //   this.resetData();
    //   this.getRequest('/dev/system/dvw/prod/today/analysis').then(res => {
    //     if(res.status===200 && res.data.code ===1000) {
    //       let data = res.data.result;
    //       this.clientTableData = data.dayFuncComponentCntAndDuration;
    //       data.dayFuncComponentCntAndDuration.map(item => {
    //         this.clientBarDataProps[0].push(item.type);
    //         this.clientBarDataProps[1].push(item.duration);
    //       });
    //       this.sdkTypeTableData = data.todayDurationBySDKType;
    //       data.todayDurationBySDKType.map(item => {
    //         this.sdkTypeBarDataProps[0].push(item.type);
    //         this.sdkTypeBarDataProps[1].push(item.cnt);
    //       });

    //     }
    //   })
    // },
    // getHistoryAnalysis() {
    //   let params = {
    //     type: this.dateValue
    //   }
    //   this.resetData();
    //   this.getRequest('/dev/system/dvw/prod/history/analysis',params).then(res => {
    //     if(res.status===200 && res.data.code ===1000) {
    //       let data = res.data.result;
    //       if(this.dateValue==='week') {
    //         this.clientTableData = data.weekFuncComponentCntAndDuration;
    //         data.weekFuncComponentCntAndDuration.map(item => {
    //           this.clientBarDataProps[0].push(item.type);
    //           this.clientBarDataProps[1].push(item.duration);
    //         });
    //         this.sdkTypeTableData = data.weekDurationBySDKType;
    //         data.weekDurationBySDKType.map(item => {
    //           this.sdkTypeBarDataProps[0].push(item.type);
    //           this.sdkTypeBarDataProps[1].push(item.cnt);
    //         });
    //       }
    //       if(this.dateValue==='month') {
    //         this.clientTableData = data.monthFuncComponentCntAndDuration;
    //         data.monthFuncComponentCntAndDuration.map(item => {
    //           this.clientBarDataProps[0].push(item.type);
    //           this.clientBarDataProps[1].push(item.duration);
    //         });
    //         this.sdkTypeTableData = data.monthDurationBySDKType;
    //         data.monthDurationBySDKType.map(item => {
    //           this.sdkTypeBarDataProps[0].push(item.type);
    //           this.sdkTypeBarDataProps[1].push(item.cnt);
    //         });
    //       }
    //       if(this.dateValue==='year') {
    //         this.clientTableData = data.yearFuncComponentCntAndDuration;
    //         data.yearFuncComponentCntAndDuration.map(item => {
    //           this.clientBarDataProps[0].push(item.type);
    //           this.clientBarDataProps[1].push(item.duration);
    //         });
    //         this.sdkTypeTableData = data.yearDurationBySDKType;
    //         if(data.yearDurationBySDKType) data.yearDurationBySDKType.map(item => {
    //           this.sdkTypeBarDataProps[0].push(item.type);
    //           this.sdkTypeBarDataProps[1].push(item.cnt);
    //         });
    //       }
    //     }
    //   })
    // },
    resetData() {
      this.clientTableData = [];
      this.sdkTypeTableData = [];
      this.clientBarDataProps = [[],[]];
      this.sdkTypeBarDataProps = [[],[]];
    }
  }
}
</script>
<style lang='scss' scoped>
 .developer {
   .choose-date {
     height: 39px;
     margin-top: 30px;
     margin-bottom: 15px;
     border-bottom: 1px solid #333;
     padding-bottom: 10px;
   }
  //  图表标题总结
  .summary-row {
    box-sizing: border-box;
    >div:nth-of-type(1) {
      padding-right: 100px;
      box-sizing: border-box;
    }
  }
  .title-block {
      box-sizing: border-box;
      margin-bottom: 20px;
      >div:nth-of-type(1) {
        height: 100%;
      background: #33CDCD;
      border-radius: 10px;
      padding: 10px 15px;
      box-sizing: border-box;
      font-size: 20px;
      color:#fff;
      vertical-align: bottom;
      }
      >div:nth-of-type(2),
      >div:nth-of-type(3) {
        font-size: 14px;
        >i {
          display: inlie-block;
          font-size: 36px;
          border-bottom: 1px solid #000;
          font-weight: 600;
          padding: 5px 10px 0 10px;
        }
      }
    }
   .chart-summary {
      box-sizing: border-box;
     >div:nth-of-type(1) {
       box-sizing: border-box;
     }
   }
 }
 </style>
